import React, { FC, useEffect, useState } from "react";
import classes from "./SearchTags.module.scss";
import { ReactComponent as CloseIcon } from "../../assets/icons/tagClose.svg";
import isLayoutMobile from "../../helpers/isLayoutMobile";

import { Button } from "../Button/Button";
import { useRefinementList } from "react-instantsearch";

type tagOption = {
  /** Name */
  name?: string | undefined;
  /** Tag */
  tag?: string | undefined;
};

type Props = {
  showAll: string;
  showLess: string;
  tagOptions: tagOption[];
  transformFunction?: (country: string) => string;
};

export const SearchTags: FC<Props> = ({
  showAll,
  showLess,

  tagOptions,
}) => {
  const { refine, items } = useRefinementList(
    { attribute: "country" },
    {
      $$widgetType: "ais.refinementList",
    }
  );
  const [searchTags, setSearchTags] = useState<string[]>(
    items.filter((item) => item.isRefined).map((item) => item.label)
  );

  const handleCountryRemove = (country: string) => {
    refine(country);
  };
  const [isMobile, setIsMobile] = useState(isLayoutMobile());
  const [isLengthLimited, setIsLengthLimited] = useState(isMobile);
  const [shownValues, setShownValues] = useState<string[]>([] as string[]);

  const [optionsMap, setOptionsMap] = useState<Object>({});

  useEffect(() => {
    if (tagOptions) {
      const map = {};
      tagOptions.forEach((option) => {
        // @ts-ignore
        map[option.tag] = option.name;
      });
      setOptionsMap(map);
      // console.log({ map });
    }
  }, [tagOptions]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isLayoutMobile());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setIsLengthLimited(false);
    } else {
      setIsLengthLimited(true);
    }
  }, [isMobile]);

  const toggleShowMore = () => {
    setIsLengthLimited(!isLengthLimited);
  };

  useEffect(() => {
    setSearchTags(
      items.filter((item) => item.isRefined).map((item) => item.label)
    );
  }, [items]);
  useEffect(() => {
    if (isLengthLimited) {
      setShownValues(searchTags.slice(0, 3) || []);
    } else {
      setShownValues(searchTags || []);
    }
  }, [isLengthLimited, searchTags]);

  return (
    <ul className={classes.bar}>
      {shownValues.map((tagValue, index) => {
        return (
          <li key={`${tagValue}-${index}`} className={classes.tag}>
            {/* @ts-ignore */}
            <div>{optionsMap ? optionsMap[tagValue] : tagValue}</div>
            <button
              className={classes.closeButton}
              onClick={() => {
                handleCountryRemove(tagValue);
              }}
            >
              <CloseIcon className={classes.closeIcon} />
            </button>
          </li>
        );
      })}
      {isMobile && searchTags && searchTags.length > 3 && (
        <div className={classes.showAll}>
          <Button variant="textOnly" onClick={toggleShowMore}>
            {isLengthLimited ? showAll : showLess}
          </Button>
        </div>
      )}
    </ul>
  );
};
